import { render, staticRenderFns } from "./widget_bStore.vue?vue&type=template&id=34e0e4a9&scoped=true"
import script from "./widget_bStore.vue?vue&type=script&lang=js"
export * from "./widget_bStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e0e4a9",
  null
  
)

export default component.exports